export default __webpack_public_path__ + "static/media/qa.b45116a3.svg";